import React, { useState } from "react";

export default function Base64Tool() {
  const [input, setInput] = useState("");
  const [output, setOutput] = useState("");
  const [error, setError] = useState("");

  const handleEncode = () => {
    try {
      setOutput(btoa(input));
      setError("");
    } catch (err) {
      setError("Encoding failed. Make sure input is a valid string.");
    }
  };

  const handleDecode = () => {
    try {
      setOutput(atob(input));
      setError("");
    } catch (err) {
      setError("Decoding failed. Make sure input is a valid Base64 string.");
    }
  };

  return (
    <>
      <style>{`
        textarea.form-control,
        textarea.form-control:focus {
          background-color: #272822;
          color: white;
        }
        textarea.form-control::placeholder {
          color: #ccc;
          opacity: 1;
        }
      `}</style>
      <div
        style={{
          padding: "0.5rem",
          fontFamily: "Arial",
        }}
      >
        <h2>Base64 Encoder / Decoder</h2>
        <div className="container mt-3 p-3 bg-white rounded shadow-sm border">
          <div className="mb-3">
            <textarea
              className="form-control"
              rows={8}
              placeholder="Enter text or base64 string..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
            ></textarea>
          </div>

          <div className="mb-3 text-center">
            <button className="btn btn-primary me-2" onClick={handleEncode}>
              Encode
            </button>
            <button className="btn btn-success" onClick={handleDecode}>
              Decode
            </button>
          </div>

          {output && (
            <div className="mb-3">
              <label className="form-label">Result:</label>
              <textarea
                className="form-control"
                rows={8}
                value={output}
                readOnly
              />
            </div>
          )}

          {error && <div className="alert alert-danger">{error}</div>}
        </div>
      </div>
    </>
  );
}
